import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_ALL_DIVIDENDS } from "../../../config/api";

export const getAllDividends = createAsyncThunk(
  "stocks/getAllDividends",
  async (arg = {}, { rejectWithValue }) => {
    const queryParams = arg || {};
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_ALL_DIVIDENDS,
        queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
